var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossThinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8122 0.5L0.962402 20.298",
    stroke: "#2E3838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16479 0.702148L21.0146 20.5001",
    stroke: "#2E3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThinBlack);
export default __webpack_public_path__ + "static/media/cross-thin-black.7670a8215093344618c041e8f2455077.svg";
export { ForwardRef as ReactComponent };